import api from './api';

const service = {
  async searchArea(params) {
    return await api.get(`/eprx-forecast/area`, { params });
  },
  async searchMarket(params) {
    return await api.get(`/eprx-forecast/market`, { params });
  },
  async searchForecast(params) {
    return await api.get(`/eprx-forecast/forecast`, { params });
  },
}

export default service;